import React from "react";
import { number, string } from "prop-types";

import GlobalState from "src/shared/utilities/globalState";

import getCurrentUser from "../authentication/src/helpers/getCurrentUser";
import { linkIsPressed } from "./analytics/ga";
import * as S from "./styled";

const VirtualOpenHouseJoinLink = props => {
  const isUserLoggedIn = async callback => {
    const viewerInfo = await getCurrentUser();

    return callback(!!viewerInfo);
  };

  const redirectToMeeting = () => {
    const { itemId, meetingUrl } = props;

    linkIsPressed(itemId);
    window.open(meetingUrl, "_blank");
  };

  const handleClick = () => {
    isUserLoggedIn(loggedIn => {
      if (loggedIn) {
        redirectToMeeting();
      } else {
        GlobalState.get("callbacks").accountCreated = undefined;
        GlobalState.get("callbacks").login = undefined;

        window.gon.state.triggerScenario("");
        GlobalState.registerCallback("accountCreated", redirectToMeeting);
        GlobalState.registerCallback("login", redirectToMeeting);
      }
    });
  };

  return <S.Link onClick={handleClick}>Join</S.Link>;
};

VirtualOpenHouseJoinLink.propTypes = {
  itemId: number.isRequired,
  meetingUrl: string.isRequired
};

export default VirtualOpenHouseJoinLink;
